import React from 'react';
import styles from './navigation.module.css';

interface NavBubbleProps {
    children: React.ReactNode;
}

function NavBubble({ children }: NavBubbleProps): React.ReactElement<NavBubbleProps> {
    return <div className={styles.NavBubble}>{children}</div>;
}

export default NavBubble;
